import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStamps(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/stamps", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchStamp(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/stamps/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editStamp(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/stamps", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteStamp(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/stamps", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
